"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function populateUsers(userIds, siteMembersMap) {
    return userIds
        .map(function (userId) { return siteMembersMap[userId]; })
        .filter(function (value) { return !!value; });
}
exports.populateUsers = populateUsers;
function getReactionsSummaryMap(reactions, siteMembersMap) {
    return reactions.reduce(function (acc, userReaction) {
        var _a;
        var reactionCode = userReaction.reaction.reactionCode;
        var reaction = acc[reactionCode] || {
            total: 0,
            users: [],
        };
        return tslib_1.__assign({}, acc, (_a = {}, _a[reactionCode] = {
            total: reaction.total + 1,
            users: reaction.users.concat(populateUsers([userReaction.userId], siteMembersMap)),
            reactionCode: reactionCode,
        }, _a));
    }, {});
}
exports.getReactionsSummaryMap = getReactionsSummaryMap;
function getReactionsSummary(reactions, siteMembersMap) {
    return Object.values(getReactionsSummaryMap(reactions, siteMembersMap));
}
exports.getReactionsSummary = getReactionsSummary;
function getLikeSummary(usersReactionsMap) {
    return (usersReactionsMap['❤️'] || {
        reactionCode: '❤️',
        total: 0,
        users: [],
    });
}
exports.getLikeSummary = getLikeSummary;
//# sourceMappingURL=selectors.js.map